<template>
  <div>
    <div v-if="showVenue" class="venue">
      {{ venue }}
    </div>
    <div class="full-address">
      {{ fullAddress }}
    </div>
    <div v-if="hideExactLocation">
      {{ i18n.t('events.details.full_address_on_rsvp') }}
    </div>
  </div>
</template>

<script>
import isPresent from '@/helpers/is-present'

export default {
  props: {
    location: {
      type: Object,
      required: true
    },
    hideExactLocation: {
      type: Boolean,
      default: false
    },
    venue: {
      type: String,
      required: false
    }
  },

  computed: {
    fullAddress() {
      let address = []
      if (this.location.street && this.location.streetNumber) {
        const street_address = this.i18n.t('public.address.format.street_with_number',
                                           { street: this.location.street,
                                             street_number: this.location.streetNumber })

        // In private venues, the name of the venue is the same as the street address (number + street name).
        // Don't include the same information twice
        if (street_address !== this.location.venue) {
          address.push(street_address)
        }
      }

      if (this.location.locality) {
        address.push(this.location.locality)
      }

      if (this.location.region) {
        address.push(this.location.region)
      }

      if (this.location.postalCode) {
        address.push(this.location.postalCode)
      }

      return address.join(', ')
    },

    showVenue() {
      return isPresent(this.venue)
    }
  }
}
</script>

<style lang="scss" scoped>
.venue {
  word-break: break-word;
}
</style>
